import React from 'react';

import { Checkbox, Typography } from '@mui/material';
import classes from './TermsCheckbox.module.scss';

type TermsCheckboxProps = {
  check: boolean;
  setCheck: (value: boolean) => void;
};

const TermsCheckbox = ({ check, setCheck }: TermsCheckboxProps) => {
  return (
    <div className={classes.checkContainer}>
      <Checkbox
        className={classes.checkBox}
        checked={check}
        onChange={(value) => setCheck(value.target.checked)}
      />
      <Typography className={classes.checkBoxText}>I agree with </Typography>
      <Typography className={classes.checkBoxLink}>Terms of Conditions</Typography>
    </div>
  );
};

export { TermsCheckbox };
